<div class="modal-container">
    <div class="modal-header">
        <p class="modal-title">UPLOAD TEMPLATE</p>
        <button type="button" class="modal-close-button" (click)="onCloseButtonClick()">
            <img [src]="closeImage | assetImageUrl" alt="Close"/>
        </button>
    </div>
    <div class="modal-body">
        <div class="modal-body--upload" [ngClass]="{bgRed:(errorDetails?.message && errorDetails?.type === errorType.clientSideError)}"  appDragDrop (onFileDropped)="selectFile($event)">
            <ng-container *ngIf="(fileName && fileExtension); else browseFile" >
              <div class="modal-body--fileupload">
              <p class="modal-body--filename">{{(errorDetails.message && errorDetails.type === errorType.clientSideError) ? errorDetails.message : fileName}}</p>
              <label class="browse-para">
              <input [disabled]="uploadStatus === uploadStatusEnum.started || uploadStatus === uploadStatusEnum.completed" type="file" style="display: none" (click)="clearValue($event)" [accept]="fileExtensions.DOT_XLSX + ',' + fileExtensions.DOT_XLSM"
                  (change)="selectFile($event)" />
                <a style="cursor:pointer" [ngClass]="{ browseDisabled : (uploadStatus === uploadStatusEnum.started || uploadStatus === uploadStatusEnum.completed)}">browse</a>
                </label>
              </div>
            </ng-container>
            
            <ng-template #browseFile>
              <div class="modal-body--fileupload">
                <span class="browse-para">Drag and drop files here or click here to </span>
                <label class="browse-para">
                <input type="file" style="display: none" (click)="clearValue($event)"
                  (change)="selectFile($event)" />
                <a style="cursor:pointer">browse</a>
                </label>
                <span class="browse-para"> Only one entity viewer template can be uploaded. </span>
              </div>
            </ng-template>
        </div>
        <button type="button" class="modal-body--uploadBtn" [ngClass]="{uploadEnabled:(uploadButtonEnabled && !errorDetails.message),uploadDisabled:(!uploadButtonEnabled || errorDetails.message)}" (click)="onStartUploadButtonClick()">
            Start Uploading <img [ngClass]="{uploadEnabled:(uploadButtonEnabled && !errorDetails.message),uploadDisabled:(!uploadButtonEnabled || errorDetails.message)}" [src]="uploadIcon | assetImageUrl" alt="Upload"/>
        </button>
    </div>

    <div class="modal-footer">
      <div class="modal-footer--upload-status">
          <ng-container *ngIf="uploadStatus === uploadStatusEnum.started || uploadStatus === uploadStatusEnum.completed || uploadStatus === uploadStatusEnum.processed">
            <p class="upload-status--title">Uploaded files</p>
            <div class="upload-status--content">
              <img [src]="'graph-icon.svg' | assetImageUrl" alt="Graph Icon"/>
              <div class="upload-status--info">
                <div class="info-top">
                  <p class="upload-status--filename">{{fileName}}</p>
                  <div class="info-top--icons">
                    <div class="upload-status--icon" *ngIf="uploadStatus === uploadStatusEnum.processed">
                      <img [src]="'check-icon.svg' | assetImageUrl" alt="Check"/>
                    </div>
                    <button type="button" *ngIf="uploadStatus !== uploadStatusEnum.processed" class="modal-close-button" (click)="onCancelProgress()">
                      <img [src]="closeImage | assetImageUrl" alt="Close"/>
                    </button>
                  </div>
                </div>
                <mat-progress-bar [mode]="((uploadStatus === uploadStatusEnum.started || uploadStatus === uploadStatusEnum.completed) && progress === 100) ? 'indeterminate' : 'determinate'" [value]="progress"></mat-progress-bar>
                <div class="info-bottom">
                  <ng-container *ngIf="uploadStatus === uploadStatusEnum.started">
                    <p class="upload-status--message">{{progress != 100 ? progress + '% completed' : ''}} {{progress === 100 ? 'Template upload in progress':''}}</p>
                    <p class="upload-status--filesize" *ngIf="progress < 100">({{speed}} {{unit}}/sec)</p>
                  </ng-container>
                  <ng-container *ngIf="uploadStatus === uploadStatusEnum.completed">
                    <p class="upload-status--message">Template uploaded successfully and is getting processed</p>
                  </ng-container>
                  <ng-container *ngIf="uploadStatus === uploadStatusEnum.processed">
                    <p class="upload-status--message">Template processed successfully</p>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-container>
  
          
          <ng-container *ngIf="uploadStatus === uploadStatusEnum.failed">
              <p class="upload-status--title">Uploaded files</p>
              <div class="upload-status--content">
                <img [src]="'graph-icon.svg' | assetImageUrl" alt="Graph"/>
                <div class="upload-status--info">
                  <div class="info-top">
                    <p class="upload-status--filename">{{fileName}}</p>
                    <div class="info-top--icons">
                      <div class="upload-status--icon"><img [src]="'Alert.png' | assetImageUrl" alt="Alert"/></div>
                      <button type="button" class="modal-close-button">
                        <img onkeypress="" (click)="onCloseButtonClick()" *ngIf="uploadStatus === uploadStatusEnum.started" [src]="closeImage | assetImageUrl" alt="Close"/>
                        <img onkeypress="" (click)="onCloseButtonClick()" *ngIf="uploadStatus === uploadStatusEnum.completed" [src]="closeImage | assetImageUrl" alt="Close"/>
                        <img onkeypress="" (click)="retryUpload()" *ngIf="uploadStatus === uploadStatusEnum.failed" [src]="retryImage | assetImageUrl" alt="Retry"/>
                      </button>
                    </div>
                  </div>
                  <div class="progress" style="height: 4px">
                    <div class="progress-bar bg-danger" role="progressbar" aria-valuenow="70"
                    aria-valuemin="0" aria-valuemax="100" style="width:100%;">
                    </div>
                  </div>
                  <div class="info-bottom">
                    <ol *ngIf="errorMessageType !== 'string'" class="error-list">
                        <li class="upload-status--message" *ngFor="let message of errorDetails.message">{{message}}</li>
                    </ol>

                    <ol *ngIf="errorMessageType === 'string'" class="error-list">
                      <li class="upload-status--message">{{errorDetails.message}}</li>
                    </ol>
                  </div>
                </div>
              </div>
            </ng-container>
          
         
      </div>
     <div class="modal-footer--btn-container">
        <button type="button" (click)="onCancelButtonClick()" [ngClass]="{isDisabled : uploadStatus === uploadStatusEnum.processed}">
          Cancel
        </button>
        <button type="button" [ngClass]="{isDisabled : !enableFinishButton}" (click)="onFinishButtonClick()">
          Finish
        </button>
     </div>
  </div>
</div>